import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import Paginator from "react-hooks-paginator";
import ShopSidebar from "./containers/ShopSidebar";
import ShopTopbar from "../../flone/wrappers/product/ShopTopbar";
import ShopProducts from "../../flone/wrappers/product/ShopProducts";
import BaseLayout from "../../components/BaseLayout";
import ShopGridStandardViewModel from "./viewModel";
import ShopCategoryDescription from "./containers/ShopCategoryDescription";
import ShopCategoryBanners from "./containers/ShopCategoryBanners";
import { getMultiLangProperty } from "../../helpers/generalHelper";

const ShopGridStandard = () => {
  const { t, i18n } = useTranslation();
  const {
    layout,
    productListWithStock,
    searchKeyword,
    pathname,
    getLayout,
    getFilterSortParams,
    onSearch,
    searchFilters,
    setCurrentPage,
    setOffset,
    totalRecords,
    addToCart,
    currency,
    cartItems,
    wishlistItems,
    compareItems,
    merchants,
    setIsQRScannerOpen,
    setSelectedProduct,
    selectedKey,
    selectedCategory,
    metaTitle,
    metaTags,
  } = useContext(ShopGridStandardViewModel.Context);

  return (
    <BaseLayout
      breadcrumbsItems={[
        { label: t("homepage"), to: `${process.env.PUBLIC_URL}/` },
        {
          label:
            getMultiLangProperty(selectedCategory?.name, i18n.language) ||
            t("productList.allProducts"),
          to: process.env.PUBLIC_URL + pathname,
        },
      ]}
      metaTitle={t("productList.metaTitle")}
      metaName={t("productList.metaName")}
      metaContent={t("productList.metaContent")}
      title={metaTitle}
      metaTags={metaTags}
    >
      <div className="shop-area pt-95 pb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 order-2 order-lg-1 d-none d-lg-block">
              {/* shop sidebar */}
              <ShopSidebar
                sideSpaceClass="mr-30"
                onSearch={onSearch}
                searchKeyword={searchKeyword}
                merchants={merchants}
                selectedKey={selectedKey}
              />
            </div>
            <div className="col-12 d-block d-lg-none">
              <ShopCategoryDescription selectedCategory={selectedCategory} />
            </div>
            <div className="col-lg-9 order-1 order-lg-2">
              {/* shop custom category banner */}
              <ShopCategoryBanners banners={selectedCategory?.banners || []} />

              {/* shop topbar default */}
              <ShopTopbar
                getLayout={getLayout}
                getFilterSortParams={getFilterSortParams}
                productCount={totalRecords}
                sortedProductCount={productListWithStock.length}
                sortBy={searchFilters._sort}
              />

              {/* shop page content default */}
              {productListWithStock && (
                <ShopProducts
                  layout={layout}
                  products={productListWithStock}
                  addToCart={addToCart}
                  currency={currency}
                  cartItems={cartItems}
                  wishlistItems={wishlistItems}
                  compareItems={compareItems}
                  setIsQRScannerOpen={setIsQRScannerOpen}
                  setSelectedProduct={setSelectedProduct}
                />
              )}

              {/* shop product pagination */}
              <div
                className="pro-pagination-style text-center mt-30"
                style={{ width: "100%", height: 20 }}
              >
                <Paginator
                  totalRecords={totalRecords}
                  pageLimit={searchFilters._limit}
                  pageNeighbours={2}
                  setOffset={setOffset}
                  currentPage={searchFilters._page}
                  setCurrentPage={setCurrentPage}
                  pageContainerClass="mb-0 mt-0"
                  pagePrevText="«"
                  pageNextText="»"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default ShopGridStandardViewModel.withProvider(ShopGridStandard);
